import './antennaStatusHud.scss'
import templateUrl from './antennaStatusHud.html'
import menuTemplateUrl from './antennaStatusHudMenu.html'

/**
 * Antenna Status HUD component.
 *
 * @todo Document
 *
 * @example
 * <tmr-antenna-status-hud
 *   antenna=""
 *   show-options=""
 *   on-mode-change="$ctrl.onModeChange(mode)"
 * ></tmr-antenna-status-hud>
 *
 * @type {ngComponent}
 * @prop {Antenna} antenna
 * @prop {boolean=} show-options If true, show a gear button with advanced options
 * @prop {function} on-mode-change
 */
export const tmrAntennaStatusHud = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAntennaStatusHudController',
  bindings: {
    antenna: '<',
    showOptions: '<',
    onModeChange: '&',
  },
}

/**
 * Controller of component {@link tmrAntennaStatusHud}.
 *
 * @type {ngController}
 */
export class tmrAntennaStatusHudController {
  static ngType = 'controller'

  constructor($mdPanel, $scope, $timeout, TmrLocalStorage) {
    'ngInject'
    Object.assign(this, { $mdPanel, $scope, $timeout, TmrLocalStorage })
  }

  $onInit() {
    this.antennaDescription = this.antenna.$describe()
    this.mode = this.TmrLocalStorage.get('epcReaderDefaultMode', 'persistent')
    this.$scope.$watch('$ctrl.antenna.$decoding', (isDecoding, wasDecoding) =>
      this.onChangeDecoding(isDecoding, wasDecoding)
    )
  }

  openMenu() {
    let animation = this.$mdPanel.newPanelAnimation()
    animation.openFrom('.antenna-status-hud-menu-button')
    animation.withAnimation(this.$mdPanel.animation.FADE)
    let position = this.$mdPanel
      .newPanelPosition()
      .relativeTo('.antenna-status-hud-menu-button')
      .addPanelPosition(
        this.$mdPanel.xPosition.ALIGN_END,
        this.$mdPanel.yPosition.BELOW
      )

    return this.$mdPanel.open({
      templateUrl: menuTemplateUrl,
      controller: () => this,
      controllerAs: '$ctrl',
      animation,
      position,
      panelClass: 'antenna-status-hud-menu md-whiteframe-4dp',
      clickOutsideToClose: true,
      escapeToClose: true,
    })
  }

  changeMode() {
    this.TmrLocalStorage.set('epcReaderDefaultMode', this.mode)
    this.onModeChange({ mode: this.mode })
  }

  onChangeDecoding(isDecoding, wasDecoding) {
    // Decoding started
    if (!wasDecoding && isDecoding) {
      this.startDecodingTimeout = this.$timeout(
        () => (this.decoding = true),
        400
      )
    }
    // Decoding finished
    if (wasDecoding && !isDecoding) {
      this.$timeout.cancel(this.startDecodingTimeout)
      this.decoding = false
    }
  }
}
